import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon SuccessCircleIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const SuccessCircleIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 20">
      <path d="M10,0C4.48,0,0,4.48,0,10s4.48,10,10,10s10-4.48,10-10S15.52,0,10,0z M15.29,8.85l-5.13,4.86 c-0.23,0.22-0.54,0.35-0.86,0.35c-0.34,0-0.66-0.14-0.9-0.38L5.75,11c-0.49-0.49-0.49-1.3,0-1.79s1.3-0.49,1.79,0l1.79,1.84l4.24-4 c0.5-0.47,1.3-0.45,1.77,0.05c0.47,0.5,0.45,1.3-0.05,1.77V8.85z" />
    </Icon>
  )
}
export default SuccessCircleIcon
